import { Component, Fragment } from 'react';
import { Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import ModalDestroy from '../../Components/Destroy';
import ModalResponse from '../../Components/ModalResponse';
import { Table } from '../../Components/Table';
import { getData, deleteData } from "../../servicos/api";
import { setLoaderShow, setResponseModal, setDestroyModal } from '../../reducers/index';

import colunas from './colunasTabela';

class CategoriaCliente extends Component {
    constructor(props){
        super(props);

        this.state = { 
            categorias_cliente: [],
        };

        this.getDataCategoriaCliente  = this.getDataCategoriaCliente.bind(this);
        this.destroyCategoriaCliente  = this.destroyCategoriaCliente.bind(this);
        this.loadingShow    = this.loadingShow.bind(this);
    }

    componentDidMount() {
        this.loadingShow(false);
        this.getDataCategoriaCliente();
    }

    // LOADER
    loadingShow(value) {
        let { setLoaderShow } = this.props;
        setLoaderShow(value);
    }

    async getDataCategoriaCliente(){
        this.loadingShow(true);
        var categorias_cliente = await getData(`/categoria-cliente`, this.props);
        if(categorias_cliente !== null){
            this.setState({categorias_cliente});
        }
        this.loadingShow(false);
    }

    async destroyCategoriaCliente(uuid) {
        this.loadingShow(true);
        await deleteData(`/categoria-cliente/${uuid}`, this.props);
        await this.getDataCategoriaCliente();
        this.loadingShow(false);
    }

    render(){
        let { setResponseModal, enableResponseModal, setDestroyModal, enableDestroyModal } = this.props;
        return (
            <Fragment>
                <div className="container-scroller">
                    <Navbar/>
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar/>
                        <div className="main-panel">
                            <div className="content-wrapper">
                                <div className="row">
                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <Card>
                                            <CardHeader className="bg-maskats text-center">
                                                <h4 className="headerTitle">Categorias de cliente</h4>
                                            </CardHeader>
                                            <CardBody>
                                                <div>
                                                    <Table
                                                        columns={colunas}
                                                        rows={this.state.categorias_cliente}
                                                        setDestroyModal={setDestroyModal} 
                                                        enableDestroyModal={enableDestroyModal}
                                                        next_url='categoria-cliente/formulario'
                                                    />
                                                </div>
                                            </CardBody>
                                            <CardFooter className="text-align-end bg-white">
                                                <Link replace to="/categoria-cliente/formulario">
                                                    <Button className="btn btn-sm btn-success btn-fw bd-rd-8" type="button">
                                                        <i className="fa fa-plus btn-icon-append btn-fs-def"></i>
                                                        <span className="label-button btn-fs-def">Adicionar</span>
                                                    </Button>
                                                </Link>
                                            </CardFooter>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalResponse 
                    history={this.props.history} 
                    setResponseModal={setResponseModal} 
                    enableResponseModal={enableResponseModal}
                />

                <ModalDestroy 
                    destroy={this.destroyCategoriaCliente}
                    setDestroyModal={setDestroyModal} 
                    enableDestroyModal={enableDestroyModal}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal,
        enableDestroyModal: state.enableDestroyModal,
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
    setDestroyModal: enable => dispatch(setDestroyModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoriaCliente);